<h2 mat-dialog-title>
  <i class="fa fa-share" aria-hidden="true"></i>&nbsp; Share Buyer Group "{{ group.name }}"
</h2>
<form [formGroup]="formGroup" (submit)="save()">
  <mat-dialog-content>
    <tc-select-search placeholder="Select Users" [multiple]="true" [group]="formGroup" ctrlName="users"
      [items]="users$ | async" bindValue="id" bindLabel="name">
    </tc-select-search>

    <mat-checkbox formControlName="makePublic">Make Public</mat-checkbox>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
    <button mat-raised-button type="submit" color="primary" [disabled]="saving || formGroup.invalid">
      @if (saving) {
        <mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner>
      } @else {
        <i class="fa fa-fw fa-save" aria-hidden="true"></i>
      }
      Share Group
    </button>
  </mat-dialog-actions>
</form>
